export const FF_ASSOCIATED_NAME = 'show-test-id-on-scenarios-tab';
export const FF_PARALLEL_CONCURRENCY = 'hide-parallel-concurrency-details';
export const FF_INSIGHTS = 'insights';
export const FF_ENABLE_METRICS_COLLECTOR = 'enable-metrics-collector';
export const FF_ML_SANCTUM_CONCURRENCY = 'ml_sanctum_concurrency';
export const FF_ACCESSIBILITY_TOOLS = 'lt_accessibility_flag';
export const FF_WF_DISABLE_PROJECT_CREATE = 'hye-disable-project-creation';
export const FF_WF_DISABLE_TEST_MUTING = 'hye-disable-test-muting';
export const FF_SHOW_TASK_REMARK = 'hye-task-remark';
export const FF_CYPRESS_REPORT = 'hye-cypress-atx-enabled';
export const FF_JOB_DEATAIL_V1 = 'hye-job-detail-v1';
export const FF_HIDE_GENERATE_RCA = 'hye-hide-generate-rca';
export const FF_SHOW_ERROR_MAPPING = 'hye-application-error-message';
export const FF_ENABLE_V2_APIS = 'hye-enable-v2-apis';
export const FF_LOGS_CATEGORIZATION = 'hye-logs-categorization';
export const FF_LIVE_TEST_METRIC_FE = 'hye-live-test-metric-fe';
export const FF_TEST_INSIGHT_API_DB = 'hye-test-insight-api-db';
export const FF_HIDE_VIEW_YAML = 'hye-hide-yaml-ui';
export const FF_HIDE_DELETE_ARTIFACTS = 'hye-hide-delete-artifacts';
export const FF_RBAC_ENABLED_USER = 'is_matrix_enabled';
export const FF_HYE_RBAC_ENABLED_USER = 'hye-is_matrix_enabled';
export const FF_JMETER_INFLUX_ENABLE = 'hye-enable-influx-api';
export const FF_ENABLE_RCA_V1 = 'atx-ai-rca-mode';
export const FF_ENABLE_YAML_IN_WORKFLOW = 'hye-enable-yaml-in-workflow';
export const FF_WORKFLOW_VARS = 'hye-workflow-vars';
export const FF_RE_RUN = 'hye-enable-rerun-ui';
export const FF_GUI_ENABLE = 'hye_gui_enable';
export const FF_HIDE_SYSTEM_PROXY = 'hye-hide-system-proxy';
export const FF_SHOW_WAIT_TIME = 'hye-show-wait-time';
export const FF_SHOW_WAIT_QUEUE_TIME_BOTH = 'hye-show-wait-queue-time-both';
export const FF_HIDE_RUN_ON_GITPOD = 'hye-hide-run-on-gitpod';
export const FF_JMETER_WORKFLOWS = 'hye-jmeter-workflows';
export const FF_APPEND_JOB_NUMBER = 'hyp-append-job-number'
export const FF_HIDE_STATUS_CYPRESS_CUSTOM_REPORT = 'hye-hide-status-cypress-custom-report';


export const FeatureFlag = {
  [FF_RE_RUN]: false,
  [FF_ASSOCIATED_NAME]: false,
  [FF_HIDE_VIEW_YAML]: false,
  [FF_PARALLEL_CONCURRENCY]: false,
  [FF_INSIGHTS]: false,
  [FF_ENABLE_METRICS_COLLECTOR]: false,
  [FF_ML_SANCTUM_CONCURRENCY]: false,
  [FF_ACCESSIBILITY_TOOLS]: false,
  [FF_WF_DISABLE_PROJECT_CREATE]: false,
  [FF_WF_DISABLE_TEST_MUTING]: false,
  [FF_SHOW_TASK_REMARK]: false,
  [FF_CYPRESS_REPORT]: false,
  [FF_JOB_DEATAIL_V1]: false,
  [FF_HIDE_GENERATE_RCA]: false,
  [FF_SHOW_ERROR_MAPPING]: false,
  [FF_ENABLE_V2_APIS]: false,
  [FF_LOGS_CATEGORIZATION]: false,
  [FF_LIVE_TEST_METRIC_FE]: false,
  [FF_TEST_INSIGHT_API_DB]: false,
  [FF_HIDE_DELETE_ARTIFACTS]: false,
  [FF_HYE_RBAC_ENABLED_USER]: false,
  [FF_RBAC_ENABLED_USER]: false,
  [FF_JMETER_INFLUX_ENABLE]: false,
  [FF_ENABLE_YAML_IN_WORKFLOW]: false,
  [FF_WORKFLOW_VARS]: false,
  [FF_GUI_ENABLE]: false,
  [FF_HIDE_SYSTEM_PROXY]: false,
  [FF_SHOW_WAIT_TIME]: false,
  [FF_SHOW_WAIT_QUEUE_TIME_BOTH]: false,
  [FF_HIDE_RUN_ON_GITPOD]: false,
  [FF_JMETER_WORKFLOWS]: false,
  [FF_APPEND_JOB_NUMBER]: false,
  [FF_HIDE_STATUS_CYPRESS_CUSTOM_REPORT]: false,
};
